import calcWorth from "./tickets-form/calc-worth";
import ticketsField from "./tickets-form/tickets-field";
import availability from "./tickets-form/availability";

let pricesResponse = {};
let changeDate = true;

export default {
  getPricesResponse() {
    return pricesResponse;
  }
};

$(function() {
  $(document).on("change", ".js-field-dropdown__calendar", function() {
    const form = $(this).closest(".js-product-order");
    const toursField = form.find(".js-field-dropdown__tour .js-product-field");

    calcWorth.clearTicketsField(form);

    let variationId =
      $(form)
        .find('.js-product-field[name="tour"]')
        .data("value") || form.find(".js-tourgrade").data("value");

    let firstTourGrade = form
      .find('.js-tourgrade[data-value="' + variationId + '"]')
      .first();
    // check availability on calendar change
    firstTourGrade.trigger("click");

    checkFlatpicker($(this));
  });

  $(".js-field-dropdown__label.flatpickr").on("click", () => {
    $(
      ".js-field-dropdown__label.is-open, .js-field-dropdown__hidden.is-open"
    ).removeClass("is-open");
  });

  $(".js-product-order")
    .off("click")
    .on("click", ".js-tourgrade", function chooseTour(e) {
      e.stopPropagation();

      const variationValue = $(this)
          .find(".js-field-dropdown-option__title")
          .text(),
        detailsContent = $(this)
          .find(".js-field-dropdown__addition")
          .text(),
        form = $(this).closest(".js-product-order"),
        variationId = $(this).data("value"),
        productId = form
          .find('input[name="product_id"]')
          .first()
          .val(),
        parent = $(this).closest(".js-field-dropdown__tour"),
        details = $(parent).find(".js-tour__details"),
        ticketsFieldLabel = $(parent)
          .siblings(".js-field-dropdown__tickets")
          .find(".js-field-dropdown__label"),
        ticketsFieldValue = $(parent).find('.js-product-field[name="tour"]'),
        wrap = $(parent).find(".js-field-dropdown__label");

        let timeId = 0;
        const ageBands = form
          .find(".js-field-dropdown__tickets .js-field-dropdown__hidden")
          .first()
          .clone();

      if ($(this).data("id")) {
        timeId = $(this).data("id");
      }

      /**
       * Hide broadway times selected value
       */
      if (typeof $(".js-broadway-times") !== "undifined") {
        let broadwayTimes = $(".js-broadway-times");
        broadwayTimes.find(".js-product-field").attr("title", "");
        broadwayTimes.find(".js-product-field").val("");
        broadwayTimes
          .find(".js-field-dropdown__label")
          .removeClass("has-value");
      }

      let timeObj = form.find(".js-field-dropdown__tour .js-product-field");

      timeObj.data("id", $(this).data("id"));
      timeObj.data("pk", $(this).data("pk"));


      $(".js-field-dropdown__label, .js-field-dropdown__hidden").removeClass(
        "is-open"
      );

      $(ticketsFieldValue).val(variationValue);
      $(ticketsFieldValue).attr("title", variationValue.replace(/\s+/g, " "));
      $(ticketsFieldValue).data("value", variationId);
      $(wrap).addClass("has-value");

      if (typeof productId === "undefined" || !productId) return;

      if (detailsContent.replace(/\s/g, "")) {
        $(details).addClass("is-show");
        $(details).text(detailsContent);
      }

      const addBtn = form
        .find(".js-tickets-add")
        .closest(".field-dropdown-tickets__category");
      let calendar = $(this)
        .closest(".js-product-order")
        .find(".js-field-dropdown__calendar");
      let bookingDate =
        calendar.val() ||
        $(".js-field-dropdown__calendar").val() ||
        availableDates[0];

      $.ajax({
        method: "get",
        url: "/products/" + productId + "/variations/" + variationId,
        data: {
          date: bookingDate
        },
        beforeSend: () => {
          form.find(".js-information__error-box").addClass("hidden");
          form
            .find(".js-field-dropdown__label.has-error")
            .removeClass("has-error");
          calcWorth.clearTicketsField(form);
          availability.showLoader();
        }
      })
        .done(response => {
          $(".js-information-sidebar__option").data("sortAgeBands", 0);

          if (response.isFareharbor) {
            response = appendTimeDropdown(response, form, addBtn, changeDate, timeId, ageBands);
          }

          if (response.isBroadway) {
            const { ageBands = [] } = response;
            response.ageBands = ageBands.reduce((bands, currentBand) => {
              bands[currentBand.time] = [
                ...(bands[currentBand.time] || []),
                currentBand
              ];
              return bands;
            }, {});

            response = appendBroadwayAgeBands(
              response,
              form,
              addBtn,
              changeDate
            );

            // CD 03/13/2024 TFS #18951 - If we have the start date parameter, preselect the first available time (if only one) once loaded.
            const queryParams = new URLSearchParams(window.location.search);
            if (queryParams.has('startDate')) {
              if ($('.js-broadway-time.js-broadway-remove-on-update').length == 1) {                
                var firstTimeValue = $('.js-broadway-time.js-broadway-remove-on-update');
                firstTimeValue.click();
              }
            }
          }

          pricesResponse[productId] = response;

          form.find(".js-information__error-box").addClass("hidden");
          form
            .closest(".js-field-dropdown__label.has-error")
            .removeClass("has-error");

          for (let key in response) {
            let $age = $(
                '.js-field-dropdown-tickets__category[data-id="' + key + '"]'
              ),
              $ageCost = $($age).find(".js-field-dropdown-tickets__title_cost"),
              $ageCountRequired = $($age).find(
                ".js-field-dropdown-tickets__required"
              ),
              $ageDataCost = $($age).find(".js-field-dropdown-tickets__field");
            let priceFormatted = response[key]["price_formatted"],
              minRequired = response[key]["min_count_required"],
              price = response[key]["price"];

            if (minRequired > 1) {
              $ageCountRequired.text("Minimum " + minRequired + " required.");
            }

            $($ageCost).text(priceFormatted);
            $($ageDataCost).data("cost", price);
          }

          if (!response.isBroadway) {
            $(ticketsFieldLabel).removeClass("is-disabled");
            $(ticketsFieldLabel)
              .find(".js-product-field")
              .removeAttr("disabled");
          }
          availability.hideLoader();
        })
        .fail((e, rr, ors) => availability.errorHandler(e, rr, ors, form));
    });

  $(".js-product-order").on("click", ".js-broadway-time", function(e) {
    e.stopPropagation();
    $(".js-field-dropdown__label, .js-field-dropdown__hidden").removeClass(
      "is-open"
    );

    let detailsContent = $(this)
        .find(".js-field-dropdown__addition")
        .text(),
      variationValue = $(this)
        .find(".js-field-dropdown-option__title")
        .text(),
      parent = $(this).closest(".js-field-dropdown__tour"),
      details = $(parent).find(".js-tour__details"),
      ticketsFieldValue = $(parent).find('.js-product-field[name="tour"]'),
      wrap = $(parent).find(".js-field-dropdown__label");

    $(ticketsFieldValue).val(variationValue);
    $(ticketsFieldValue).attr("title", variationValue.replace(/\s+/g, " "));
    $(wrap).addClass("has-value");

    if (detailsContent.replace(/\s/g, "")) {
      $(details).addClass("is-show");
      $(details).text(detailsContent);
    }

    let time = $(this).data("time");
    $(".js-broadway-age-band").hide();
    $(".js-broadway-age-band").each(function() {
      if ($(this).data("time") == time) {
        if ($(this).hasClass("hidden")) {
          $(this).removeClass("hidden");
        }
        $(this).show();
      }
    });
    let ticketsFieldLabel = $(".js-field-dropdown__tickets");
    $(ticketsFieldLabel).removeClass("is-disabled");
    $(ticketsFieldLabel)
      .find(".js-product-field")
      .removeAttr("disabled");
  });

  if (
    $(".js-product-order")
      .first()
      .find(".js-field-dropdown__tour")
      .data("hide")
  ) {
    $(".js-tourgrade")
      .first()
      .trigger("click");
  }

  if ($(".js-field-dropdown__tour").data("hide")) {
    $(".js-tourgrade")
      .first()
      .trigger("click");
  }

  $(".js-field-dropdown__tickets.is-open").on("click", function() {
    const form = $(".js-product-order");

    availability.checkAvailability(form);
  });

  ticketsField.changeInputNumber();

  checkFlatpicker();

  const appendTimeDropdown = (response, form, addBtn, changeDate, timeId, ageBands) => {
    let elem = form
      .find(".js-field-dropdown__tour")
      .find(".js-tourgrade")
      .first();

    $(".js-information-sidebar__option.is-active").data("sortAgeBands", 1);

    form
      .find(
        ".js-field-dropdown__tickets .js-field-dropdown__hidden .js-scrollbar"
      )
      .html("");
    form.find(".js-field-dropdown__tour").removeClass("hidden");
    form.find(".js-field-dropdown__tour .js-scrollbar").html("");

    let timeObj = form.find(".js-field-dropdown__tour .js-product-field");

    if (!timeObj.data("pk") || changeDate) {
      timeObj.attr(
        "value",
        `${response.availabilities[0].startDate} - ${response.availabilities[0].endDate}`
      );
      timeObj.attr(
        "title",
        `${response.availabilities[0].startDate} - ${response.availabilities[0].endDate}`
      );
      form
        .find(".js-tour__details")
        .text(
          `${response.availabilities[0].startDate} - ${response.availabilities[0].endDate}`
        );
      timeObj.data("pk", response.availabilities[0].pk);
      timeObj.data("id", 0);
      changeDate = false;
      timeId = 0;
    }
    // TODO REFACTOR ALL BELLOW
    response.availabilities.forEach(function(item, i) {
      let elemClone = elem.clone();
      elemClone.css("display", "block");
      elemClone.data("age-bands", item.age_bands);
      elemClone.data("pk", item.pk);
      elemClone.data("id", i);
      elemClone.data("capacity", item.capacity);
      elemClone
        .find(".js-field-dropdown-option__title")
        .text(`${item.startDate} - ${item.endDate}`);
      elemClone
        .find(".js-field-dropdown__addition")
        .text(`${item.startDate} - ${item.endDate}`);

      form.find(".js-field-dropdown__tour .js-scrollbar").append(elemClone);
    });

    let activeVariationId = $(".js-information-sidebar__option.is-active").data(
      "product-id"
    )
      ? $(".js-information-sidebar__option.is-active").data("id")
      : null;

    response.availabilities[timeId].age_bands.forEach(function(item, i) {
      let ageBand = ageBands
        .find('.js-field-dropdown-tickets__category[data-id="' + i + '"]')
        .first()
        .clone();
      if (ageBand.length > 0) {
        ageBand.data("pk", item.variation_code);
        ageBand
          .find(".js-field-dropdown-tickets__title")
          .text(item.pluralDescription);
        ageBand.find(".js-field-dropdown-tickets__age").text(item.description);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("name", item.pluralDescription);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("min", item.min_count_required);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("max", item.max_count_required);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .data("variation", item.variationId);
        ageBand.find(".js-field-dropdown-tip").text(item.pluralDescription);
        ageBand
          .find(".js-field-dropdown-tip-description")
          .text(item.description);

        if (activeVariationId && activeVariationId != item.variationId) {
          ageBand.css("display", "none");
        }

        form.find(".js-field-dropdown__tickets .js-scrollbar").append(ageBand);
      }
    });

    form.find(".js-field-dropdown__tickets .js-scrollbar").append(addBtn);

    response = response.availabilities[timeId].age_bands;

    return response;
  };

  const appendBroadwayAgeBands = (response, form, addBtn, changeDate) => {
    let simpleAgeBand = form.find(".js-simple-age-band");
    let simpleTime = form.find(".js-single-tour-time");

    $(".js-broadway-remove-on-update").remove();
    Object.keys(response.ageBands).forEach(time => {
      let timeObj = simpleTime.clone();

      timeObj.data("time", time);

      timeObj.removeClass("js-single-tour-time");
      timeObj.addClass("js-broadway-remove-on-update");

      timeObj
        .find(".js-field-dropdown-option__title")
        .text(response.ageBands[time][0].time_formatted);
      timeObj
        .find(".js-field-dropdown__addition")
        .text(response.ageBands[time][0].time_formatted);

      timeObj.removeClass("hidden");

      form.find(".js-broadway-time-wrap").append(timeObj);

      response.ageBands[time].forEach(function(element, i) {
        let ageBand = simpleAgeBand.clone();
        let ticketAge = "";
        let price = element.price_formatted;

        if (element.isRecommended) {
          ticketAge =
            "From " +
            element.currency_code +
            element.price +
            " - " +
            element.currency_code +
            element.max_price;
          price = "";
          ageBand
            .find(".js-field-dropdown-tickets__age")
            .css("font-weight", "700");
        }

        ageBand.removeClass("js-simple-age-band");
        ageBand.addClass("js-broadway-remove-on-update");
        ageBand.addClass("js-broadway-age-band");

        ageBand.data("time", time);
        ageBand.data("id", element.age_band_id);

        ageBand.find(".js-field-dropdown-tickets__title").text(element.name);
        ageBand.find(".js-field-dropdown-tip").text(element.name);
        ageBand.find(".js-field-dropdown-tickets__title_cost").text(price);
        ageBand.find(".js-field-dropdown-tickets__age").text(ticketAge);
        ageBand.find(".js-field-dropdown-tip-description").text(ticketAge);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("max", element.max_count_required);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("min", element.min_count_required);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("name", element.name);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .attr("id", element.age_band_id);
        ageBand
          .find(".js-field-dropdown-tickets__field")
          .data("cost", element.price);

        form.find(".js-field-dropdown-tickets__age-bands").append(ageBand);
      });
    });

    return response;
  };

  function checkFlatpicker(calendar) {
    const flatpickerField = calendar == undefined ? $(".js-field-dropdown__calendar") : calendar,
      flatpickerLabel = $(flatpickerField).closest(".js-field-dropdown__label");

    if (flatpickerField.val()) {
      return $(flatpickerLabel).addClass("has-value");
    }

    $(flatpickerLabel).removeClass("has-value");
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/tickets-form.js